export const ROLES = {
	A12_B: "admin",
	USER: "user",
};